import queries from '@apis/queries';
import useUser from '@hooks/auth/useUser';
import { useQuery } from '@tanstack/react-query';

import useEvent from './useEvent';

function useAttendanceEvent(eventId: string) {
    const event = useEvent(eventId);
    const { user } = useUser();
    const { data: progress } = useQuery({
        ...queries.events.attendanceProgress(eventId),
        enabled: event?.eventType === 'ATTENDANCE' && !!user,
    });
    const { data: policy } = useQuery(queries.events.attendancePolicy(eventId));
    return {
        progress,
        policy,
    };
}

export default useAttendanceEvent;
